// Hand off a task from care_coordinator to clinician. Prepends an
// "[Escalated by Care Coordinator @ <ISO>]" audit line to completion_notes.

import { eventPost } from '@/lib/events';
import { currentUpdaterRole } from '@/config/program';

export interface EscalateOpts {
  reason?: string;
  priority?: string;
  withingsUserId: string | number;
}

export async function escalateToClinician(
  taskId: string | number,
  { reason = '', priority = 'urgent', withingsUserId }: EscalateOpts,
): Promise<unknown> {
  const stamp = new Date().toISOString();
  const escalationNote = reason
    ? `[Escalated by Care Coordinator @ ${stamp}] ${reason}`
    : `[Escalated by Care Coordinator @ ${stamp}]`;
  return eventPost('task_updated', {
    task_id: taskId,
    id_dev_user: withingsUserId,
    updated_by_role: currentUpdaterRole(),
    changes: {
      owner_role: 'clinician',
      priority,
      completion_notes: escalationNote,
    },
  });
}
